export default "__VITE_ASSET__xLntaULl__"